import { alpha } from '@mui/material';
const useCalendarStyles = () => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
        },
        navGroup: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        navButton: {
            color: (theme) => theme.palette.primary.darker,
            border: 'none',
            p: 0.5
        },
        navIcon: {
            fontSize: '1.2rem'
        },
        monthTitle: {
            color: (theme) => theme.palette.text.primary,
            fontWeight: 600
        },
        dayHeaders: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 1,
            mb: 1
        },
        dayHeaderCell: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32
        },
        dayHeaderText: {
            color: (theme) => theme.palette.grey[700],
            fontWeight: 400
        },
        calendarGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 1,
            flexGrow: 1
        },
        dayCell: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
            cursor: 'pointer',
            borderRadius: 1,
            transition: 'background-color 0.2s',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
            }
        },
        dayText: {
            color: (theme) => theme.palette.grey[900]
        },
        emptyDay: {
            color: (theme) => alpha(theme.palette.grey[900], 0.25)
        },
        selectedDayText: {
            color: (theme) => theme.palette.grey[900],
            fontWeight: 'bold'
        },
        highlightedDayText: {
            color: (theme) => theme.palette.grey[900],
            fontWeight: 'bold'
        }
    };
};
export default useCalendarStyles;
